export const IS_BROWSER_MAIN_THREAD = ![typeof window, typeof document].includes("undefined");

export const IS_BROWSER_WORKER =
    typeof self === "object" &&
    typeof WorkerGlobalScope != 'undefined'


export const IS_BROWSER = IS_BROWSER_MAIN_THREAD || IS_BROWSER_WORKER;

export const IS_NODE =
  // @ts-expect-error
  typeof process !== "undefined" &&
  // @ts-expect-error
  process.versions != null &&
  // @ts-expect-error
  process.versions.node != null;




//   IS_WEB